// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"9b8a6980","76":"da582a46","143":"4eb2035d","186":"241367f8","428":"0d532bdf","439":"d49a89a9","446":"17c42eb9","516":"5fa6b7ed","571":"4fc08754","658":"91c34e2e","671":"e401303f","750":"487b9046","760":"10843c77","972":"b5c23031","974":"09463684"}[chunkId] + ".chunk.js";
};